<!--
 * @Date: 2023-01-07 12:00:49
 * @LastEditors: wyhuo2
 * @LastEditTime: 2023-01-09 00:03:36
 * @FilePath: /topze-web-one/src/views/find/Index.vue
-->
<template>
  <div class="container">
    <div class="card">
      <el-collapse v-model="activeNames" @change="handleChange">
        <el-collapse-item title="图像搜索须知" name="1">
          <ul class="buy-notice">
            <li>
              国内大多数素材网站属代理模式，您可以从国内各大素材网站上搜索，然后再使用反向搜索功能进行下载。<el-button
                type="text"
                >视频教程<i class="el-icon-question el-icon--right"></i
              ></el-button>
            </li>
            <li>
              图片格式支持jpg和png，最大不超过4M，请勿上传色情违规图片，否则您的帐户将被永远禁止！
            </li>
            <li>
              您可以在图片上点击鼠标右键，选择“复制图片地址”，然后将地址粘贴在下方输入框内搜索。
            </li>
            <li>
              识图过程会自动运行，不保证100%准确，下载前请核对一遍预览图。
            </li>
            <li style="color:red;">
              搜图系统自动协助您搜索国外9大素材网，未搜索到的图片也会产生扣费您也可以选择手动在各大素材网自己搜索！如您不同意此项，请勿购买，购买后不支持退费。
            </li>
          </ul>
        </el-collapse-item>
      </el-collapse>
    </div>

    <div class="flex-card">
      <div class="card left">
        <h1 class="card-header">识图次数</h1>
        <div class="card-body">
          <h3 class="green recognize-row">
            <i class="el-icon-bank-card"></i>
            <span class="recognize-number"> {{ userInfo.searchCount }}</span> 次
          </h3>
          <p class="grey pay-first">
            请先充值余额后再购买识图次数，已充值直接购买识图次数即可
          </p>
          <div class="dot-wrapper">
            <i class="dot primary"></i>
            购买识图次数费用将从余额扣除，请先充值余额。
          </div>
          <div class="dot-wrapper">
            <i class="dot green"></i
            >识图次数无法转换为余额，请确认需求后再进行购买。
          </div>
          <div class="dot-wrapper">
            <i class="dot grey"></i
            >系统非万能，未搜索到的图片也会产生扣费，如您不同意此项内容，请勿购买！购买后不支持退费。
          </div>

          <div class="flex bg-row">
            <div>
              <el-button type="primary" @click="gotoPay()">
                充值余额 <i class="el-icon-document-checked el-icon--right"></i
              ></el-button>
              <el-button type="text"
                >视频教程<i class="el-icon-question el-icon--right"></i
              ></el-button>
            </div>
            <img class="bg" src="@/assets/images/find/bg.png" alt="" />
          </div>
        </div>
      </div>
      <div class="right">
        <div class="card">
          <h1 class="card-header">请选择识图次数</h1>
          <div class="card-body">
            <el-select
              class="select-container"
              v-model="currentValue"
              @change="selectChange"
              placeholder="请选择"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <div>
              <el-button
                type="primary"
                icon="el-icon-plus"
                @click="sureBuyTimes"
                >确认购买</el-button
              >
            </div>
          </div>
        </div>
        <div class="card">
          <h1 class="card-header">您的余额</h1>
          <div class="card-body">
            <h3 class="primary text-center">
              <i
                class="el-icon-bank-card font-26"
                style="margin-right:0.5em"
              ></i
              >{{ userInfo.balance }}
              <span class="font-14">元</span>
            </h3>
            <div class="expire-time-container">
              <p class="text-center grey font-14">
                余额到期时间
              </p>
              <span class="expire-tag">无限期</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <h1 class="card-header">图像搜索</h1>
      <div class="card-body">
        <el-upload
          class="upload-demo"
          drag
          action
          :http-request="uploadFile"
          ref="upload"
          :limit="1"
          :file-list="fileList"
          :on-exceed="handleExceed"
          :on-remove="handleRemove"
          :before-upload="beforeUpload"
          :headers="headers"
        >
          <div class="el-upload__text">点击或拖拽上传文件,文件小于5M</div>
          <!-- <div class="el-upload__tip" slot="tip">
            只能上传jpg/png文件，且不超过2M
          </div> -->
        </el-upload>

        <div class="copy-title grey">粘贴地址</div>

        <div class="tips greenBg greenFont">
          请在原网站点击预览图，然后使用鼠标点击右键，选择“复制图片地址”后粘贴在下方输入框，推荐直接截图保存后上传。
        </div>
        <div class="tips redBg redFont">
          部分预览图链接屏蔽访问，为避免搜索失败，请直接上传预览图。
        </div>
        <div class="tips blueBg blueFont">
          系统非万能，未搜索到的图片也会产生扣费，如您不同意此项内容，请勿购买！购买后不支持退费。
        </div>

        <el-input
          class="input"
          v-model="searchUrl"
          placeholder="请在此处粘贴或输入图片网址"
        ></el-input>

        <div class="text-center">
          <el-button type="primary" icon="el-icon-search" @click="startSearch()"
            >开始搜索</el-button
          >
        </div>
      </div>
    </div>

    <div class="card">
      <div class="flex mb">
        <h1 class="half search-success-title">搜索成功列表</h1>
        <!-- <el-input
          class="search-number-input"
          placeholder="请输入编号"
          suffix-icon="el-icon-search"
          v-model="filterID"
        >
        </el-input> -->
      </div>
      <!-- <el-dropdown class="dropdown">
        <el-button type="primary" size="medium">
          复制下列编号到粘贴板<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="BatchCopy('shutterstock', $event)"
            >复制Ss</el-dropdown-item
          >
          <el-dropdown-item @click.native="BatchCopy('depositphotos', $event)"
            >复制Depositphotos</el-dropdown-item
          >
          <el-dropdown-item @click.native="BatchCopy('rfoto', $event)"
            >复制123rf</el-dropdown-item
          >
          <el-dropdown-item @click.native="BatchCopy('istockphoto', $event)"
            >复制iStockphoto</el-dropdown-item
          >
          <el-dropdown-item @click.native="BatchCopy('dreamstime', $event)"
            >复制Dreamstime</el-dropdown-item
          >
          <el-dropdown-item @click.native="BatchCopy('adobestock', $event)"
            >复制Adobestock</el-dropdown-item
          >
          <el-dropdown-item @click.native="BatchCopy('freepik', $event)"
            >复制Freepik</el-dropdown-item
          >
          <el-dropdown-item @click.native="BatchCopy('vectorstock', $event)"
            >复制Vectorstock</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown> -->
      <div class="card-body" id="position">
        <el-table
          :data="tableData"
          style="width: 100%"
          v-loading="orderLoading"
          ref="elTable"
        >
          <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
          <el-table-column prop="" label="编号" width="55">
            <template slot-scope="scope">
              {{
                scope.$index + 1 + (orderList.pageNo - 1) * orderList.pageSize
              }}
            </template>
          </el-table-column>
          <el-table-column prop="fileName" label="文件名"> </el-table-column>
          <el-table-column label="预览图">
            <template slot-scope="scope">
              <img width="60" height="60" :src="scope.row.fileUrl" />
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="搜索时间"
            :formatter="formatDate1"
          >
          </el-table-column>
          <el-table-column label="操作状态">
            <template slot-scope="scope">
              <div
                v-if="scope.row.status == 0 && scope.row.webTypes.length > 0"
              >
                <el-dropdown class="dropdown">
                  <el-button type="success" size="medium">
                    搜索完成<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-for="webType in scope.row.webTypes"
                      :key="webType"
                      @click.native="openDownloadDialog(webType, scope.row)"
                    >
                      {{ webType }}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div v-else>
                <el-button type="danger" size="medium">
                  搜索无结果
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          @size-change="handleOrderSizeChange"
          @current-change="handleCurrentOrderChange"
          :current-page="orderList.pageNo"
          :page-size="orderList.pageSize"
          :total="orderList.totalSize"
          :page-sizes="[10, 20, 30, 40]"
          layout="total, sizes, prev, pager, next, jumper"
          :hide-on-single-page="false"
        >
        </el-pagination>
      </div>
    </div>

    <div class="card">
      <h1 class="card-header">识图次数购买历史</h1>
      <div class="card-body">
        <el-table :data="historyTable" v-loading="tableLoading">
          <el-table-column prop="" label="编号" width="120"
            ><template slot-scope="scope">
              {{
                scope.$index + 1 + (searchList.pageNo - 1) * searchList.pageSize
              }}
            </template></el-table-column
          >
          <el-table-column prop="fspPayment" label="面额"> </el-table-column>
          <el-table-column
            prop="fspPaytime"
            label="时间"
            :formatter="formatDate"
          >
          </el-table-column>
          <el-table-column
            prop="status"
            label="状态"
            :formatter="formatUseState"
          >
          </el-table-column>
        </el-table>
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchList.pageNo"
          :page-size="searchList.pageSize"
          :total="searchList.totalSize"
          :page-sizes="[10, 20, 30, 40]"
          layout="total, sizes, prev, pager, next, jumper"
          :hide-on-single-page="false"
        >
        </el-pagination>
      </div>
    </div>
    <Dialog
      :dialogVisible="dialogTableVisible"
      @closeDialog="closeConstDetailPop"
      :data="tableIDDatas"
      :clearflag="isClearFlag"
      :netError="isNetError"
      :isloading="tableLoading1"
      @noBanlance="noBanlances"
    />
  </div>
</template>
<script>
import { getSessionUser } from "../../api/auth";
import {
  findTimesPay,
  findTimesList,
  findByImageUrls,
  findOrderList,
  uploadLocalFile,
} from "../../api/charge";
import {
  setToken,
  getTempUser,
  getToken,
  getNewUser,
} from "../../utils/storage";
import { searchImage } from "../../api/downLoad";
import { message } from "@/utils/resetMessage";
import { MessageBox } from "element-ui";
import Dialog from "./module/dialog.vue";
import Clipboard from "clipboard";
export default {
  components: {
    Dialog,
  },
  data() {
    return {
      userInfo: {
        balance: 0.0,
        email: "",
        phone: "",
        faiUuid: 0,
        searchCount: 0,
      },
      dialogTableVisible: false, //费用明细弹窗
      isDownloading: false, // 是否正在下载
      isClearFlag: false, //是否需要清除Url
      isNetError: false, //是否网络通畅标记
      //上传后的文件列表
      fileList: [],
      // 允许的文件类型
      fileType: ["png", "jpg", "bmp", "jpeg", "webp", "gif", "tiff"],
      // 运行上传文件大小，单位 M
      fileSize: 2,
      //请求头
      headers: { "Content-Type": "multipart/form-data" },
      activeNames: ["1"],
      searchUrl: "",
      filterID: "",
      historyTable: [],
      tableData: [],
      tableIDDatas: [],
      options: [
        {
          value: "1",
          label: "1元1次",
          price: 1,
          times: 1,
        },
        {
          value: "2",
          label: "5元8次",
          price: 5,
          times: 8,
        },
        {
          value: "3",
          label: "20元40次",
          price: 20,
          times: 40,
        },
        {
          value: "4",
          label: "50元120次",
          price: 50,
          times: 120,
        },
      ],
      currentValue: "1",
      currentPrice: 1,
      currentTimes: 1,
      searchList: {
        pageNo: 1,
        pageSize: 10,
        totalSize: 0,
      },
      orderList: {
        pageNo: 1,
        pageSize: 10,
        totalSize: 0,
      },
      tableLoading: false,
      tableLoading1: false, //加载数据效果
      orderLoading: false,
    };
  },
  mounted() {
    //自动锚点
    this.$EventBus.$on("moveNext", (data) => {
      if (data == "1") {
        this.goAnchor("position");
      }
    });
    // if (getNewUser() == 0) {
    //   this.$store.commit("updateShowBottum", true);
    //   this.$store.commit("updateShowPost", true);
    // }

    this.getUserList();
    //订单列表
    this.getOrderTableDatas();
    //搜索列表
    this.getSearchDatas();
  },
  methods: {
    goAnchor(e) {
      var id = "#" + e;
      document.querySelector(id).scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest",
      });
    },
    //批量复制ID
    BatchCopy(webType, e) {
      let items = this.$refs.elTable.selection;
      if (items == null || items.length == 0) {
        message.error({
          message: "请先选择复制的搜索结果",
          showClose: true,
          duration: 4000,
          offset: 100,
        });
        return;
      }
      var text = "";
      items.forEach((item, index) => {
        let obj = JSON.parse(item.searchResult);
        let imageIDList = obj[webType];
        Object.keys(imageIDList).forEach((key) => {
          text += key + "\n";
        });
      });
      const clipboard = new Clipboard(e.target, { text: () => text });
      clipboard.on("success", (e) => {
        message.success({
          message: "复制成功",
          duration: 4000,
          offset: 80,
        });
        // 释放内存
        clipboard.off("error");
        clipboard.off("success");
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        message.success({
          message: "复制失败，请重试",
          duration: 4000,
          offset: 80,
        });
        // 释放内存
        clipboard.off("error");
        clipboard.off("success");
        clipboard.destroy();
      });
      clipboard.onClick(e);
    },
    closeConstDetailPop() {
      this.dialogTableVisible = false;
    },
    handleChange(val) {
      console.log(val);
    },
    handleSizeChange(val) {
      this.searchList.pageSize = val;
      this.searchList.pageNo = 1;
      this.getOrderTableDatas();
    },
    handleCurrentChange(val) {
      this.searchList.pageNo = val;
      this.getOrderTableDatas();
    },
    handleOrderSizeChange(val) {
      this.orderList.pageSize = val;
      this.orderList.pageNo = 1;
      this.getSearchDatas();
    },
    handleCurrentOrderChange(val) {
      this.orderList.pageNo = val;
      this.getSearchDatas();
    },
    getOrderTableDatas() {
      this.tableLoading = true;
      let dataform = {
        pageNo: this.searchList.pageNo,
        pageSize: this.searchList.pageSize,
      };
      findTimesList(dataform)
        .then((result) => {
          this.tableLoading = false;
          if (result.datalists == null) {
            this.searchList.totalSize = 0;
          } else {
            this.searchList.totalSize = result.total;
          }
          this.historyTable = result.datalists;
        })
        .catch((error) => {
          this.tableLoading = false;
        });
    },
    getUserList() {
      getSessionUser({})
        .then((result) => {
          if (result != null) {
            this.$store.dispatch("setUserInfo", result);
            this.userInfo.balance = result.blance;
            this.userInfo.email = result.mail;
            this.userInfo.phone = result.mobile;
            this.userInfo.faiUuid = result.faiUuid;
            this.userInfo.searchCount =
              result.searchCount == null ? 0 : result.searchCount;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //上传文件之前
    beforeUpload(file) {
      if (file.type != "" || file.type != null || file.type != undefined) {
        //截取文件的后缀，判断文件类型
        const FileExt = file.name.replace(/.+\./, "").toLowerCase();
        //计算文件的大小
        const isLt5M = file.size / 1024 / 1024 < 5; //这里做文件大小限制
        //如果大于50M
        if (!isLt5M) {
          message.error({
            message: "上传文件大小不能超过 5MB!",
            showClose: true,
            duration: 4000,
            offset: 100,
          });
          return false;
        }
        //如果文件类型不在允许上传的范围内
        if (this.fileType.includes(FileExt)) {
          return true;
        } else {
          message.error({
            message: "上传文件格式不正确!",
            showClose: true,
            duration: 4000,
            offset: 100,
          });
          return false;
        }
      }
    },
    //上传了的文件给移除的事件，由于我没有用到默认的展示，所以没有用到
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.fileList = fileList;
    },
    //超出文件个数的回调
    handleExceed() {
      message.error({
        message: "每次搜索限制一张图片",
        showClose: true,
        duration: 4000,
        offset: 100,
      });
      return;
    },
    //上传文件的事件
    uploadFile(item) {
      //上传文件的需要formdata类型;所以要转
      let FormDatas = new FormData();
      FormDatas.append("file", item.file);
      uploadLocalFile(FormDatas).then((res) => {
        if (res != "" || res != null) {
          this.fileList.push(item.file); //成功过后手动将文件添加到展示列表里
          let i = this.fileList.indexOf(item.file);
          this.fileList[i].url = window.baseUrl + res; //id也添加进去，最后整个大表单提交的时候需要的
          //测试数据
          //this.fileList[i].url = "https://image.shutterstock.com/image-illustration/background-dog-paw-print-bone-260nw-134400698.jpg";
        }
      });
    },
    openDownloadDialog(webType, row) {
      this.dialogTableVisible = true;
      this.tableIDDatas = [];
      let item = JSON.parse(row.searchResult);
      let imageIDList = [];
      if (webType == "ss") {
        imageIDList = item["shutterstock"];
      } else {
        imageIDList = item[webType];
      }

      if (imageIDList == null || imageIDList.length == 0) {
        //提示
        message.error({
          message: "该素材网站暂无匹配内容",
          showClose: true,
          duration: 4000,
          offset: 100,
        });
        return;
      }
      if (webType === "ss") {
        webType = "shutterstock_V2";
      }
      this.tableLoading1 = true;
      //进行搜索显示
      Object.keys(imageIDList).forEach(async (key) => {
        try {
          let obj = imageIDList[key];
          let dataform = {
            webType: webType,
            imageID: key,
          };
          let res = await searchImage(dataform);
          if (res.recCode != null && res.recCode != "") {
            this.getTableDatas(res, obj.iconUrl, obj.url, webType);
          } else {
            let res = await searchImage(dataform);
            if (res.recCode != null && res.recCode != "") {
              this.getTableDatas(res, obj.iconUrl, obj.url, webType);
            } else {
              this.isNetError = true;
              message.error({
                message: "网络异常，请重试",
                showClose: true,
                duration: 4000,
                offset: 100,
              });
            }
          }
          this.tableLoading1 = false;
        } catch (e) {
          try {
            let res = await searchImage(dataform);
            if (res.recCode != null && res.recCode != "") {
              console.log(JSON.stringify(obj));
              this.getTableDatas(res, obj.iconUrl, obj.url, webType);
            }
          } catch (e) {
            this.isNetError = true;
            message.error({
              message: "网络异常，请重试",
              showClose: true,
              duration: 4000,
              offset: 100,
            });
          }
          this.tableLoading1 = false;
        }
      });
    },
    //获取表格数据
    getTableDatas(result, iconUrl, bakeUrl, webType) {
      this.dataForm = {
        img: "", //缩略图
        url: "", //图片
        id: "", //图片ID
        imgSize: "", //图片大小
        complete: false, //操作状态为按钮
        loading: false, //操作状态为加载
        saleType: "", //默认为空
        price: 0, //图片价格
        priceList: [], //视频价格
        videoType: 0, //视频格式
        isfk: false, //是否4k
        isyx: false, //是否严选
        orgPrice: "", //原价
        balance: "", //用户余额
        value: 4, //图片类型默认值
        disabled: false, //是否可选
        videoValue: 0, //视频类型默认值
        videoLabel: "", //视频标签
        videoDisabled: false, //是否可选
        videoOptions: [], //视频类型
        options: [], //图片类型
        webType: webType, //网站类型
        isVideo: false, //是否视频
        downurl: "", //主下载链接
        downurl2: "", //备用下载链接
        type: true, //正常
        showType: true, //是否显示类型
        msg: "", //提示消息
        isBuy: false, //是否购买过
        isCos: false, //是否腾讯云
        errorIcon: "", //飞鸟 链接
        checking: false, //是否在查状态
        isOffset: false, //高级图
      };
      //请求成功后赋值，并且去掉加载效果
      if (result.status == 0) {
        this.dataForm.id = result.recCode;
        this.dataForm.price = result.price;
        this.dataForm.orgPrice = result.orgPrice;
        this.dataForm.isVideo = false;
        this.dataForm.img = iconUrl;
        this.dataForm.url = bakeUrl;
        if (result.searchDTO.picType == 0) {
          //0为jpg
          this.dataForm.imgSize = result.detailJson[0].px;
          this.dataForm.value = 0;
          this.dataForm.options = [{ value: 0, label: "JPG" }];
        } else if (result.searchDTO.picType == 1) {
          //4为eps
          this.dataForm.value = 1;
          this.dataForm.options = [{ value: 1, label: "ait" }];
        } else if (result.searchDTO.picType == 2) {
          //4为eps
          this.dataForm.value = 2;
          this.dataForm.options = [{ value: 2, label: "indt" }];
        } else if (result.searchDTO.picType == 3) {
          //4为eps
          this.dataForm.value = 3;
          this.dataForm.options = [{ value: 3, label: "psdt" }];
        } else if (result.searchDTO.picType == 4) {
          //4为eps
          this.dataForm.value = 4;
          this.dataForm.options = [{ value: 4, label: "EPS" }];
        } else if (result.searchDTO.picType == 9) {
          this.dataForm.showType = false;
        } else if (result.searchDTO.picType == 10) {
          //10为eps
          this.dataForm.value = 10;
          this.dataForm.options = [{ value: 10, label: "svg" }];
        } else if (result.searchDTO.picType == 11) {
          //11为eps
          this.dataForm.value = 11;
          this.dataForm.options = [{ value: 11, label: "ai" }];
        } else if (result.searchDTO.picType == 12) {
          //11为eps
          this.dataForm.value = 12;
          this.dataForm.options = [{ value: 12, label: "mdl" }];
        }
        this.dataForm.isCos = result.detailJson[0].isCos;
        //设置是否购买
        this.dataForm.isBuy = result.detailJson[0].isBuy;
        if (this.dataForm.isBuy) {
          this.dataForm.msg = "免费";
        }
        this.dataForm.isOffset =
          result.searchDTO.is_loaded == "2" ? true : false;
      } else {
        this.dataForm.id = result.recCode;
        this.dataForm.msg = result.msg;
        this.dataForm.type = false;
      }
      this.tableIDDatas.push(this.dataForm);
    },
    startSearch() {
      if (
        (this.searchUrl === null || this.searchUrl === "") &&
        this.fileList.length == 0
      ) {
        message.error({
          message: "请先上传图片或者填入图片链接",
          duration: 4000,
          offset: 80,
        });
        return;
      }
      MessageBox.confirm(
        "提交后即刻扣除搜索次数余额，如无结果，也会扣除搜索次数！是否确认？",
        "温馨提示",
        {
          confirmButtonText: "确定搜索",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        let dataform = { url: "" };
        if (this.fileList.length > 0) {
          dataform.url = this.fileList[0].url;
        } else {
          let reg = /(https?|http):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/;
          if (!reg.test(this.searchUrl)) {
            message.error({
              message: "请输入正确的URL链接",
              duration: 4000,
              offset: 80,
            });
            return;
          }
          dataform.url = this.searchUrl;
        }
        findByImageUrls(dataform)
          .then((result) => {
            message.success({
              message: "查询成功",
              duration: 4000,
              offset: 80,
            });
            this.$EventBus.$emit("moveNext", "1");
            this.getSearchDatas();
            this.getUserList();
            this.searchUrl = "";
            this.fileList = [];
          })
          .catch((error) => {
            message.error({
              message: error.message,
              duration: 4000,
              offset: 80,
            });
          });
      });
    },
    getSearchDatas() {
      this.orderLoading = true;
      let dataform = {
        pageNo: this.orderList.pageNo,
        pageSize: this.orderList.pageSize,
      };
      findOrderList(dataform)
        .then((result) => {
          this.orderLoading = false;
          if (result.datalists == null) {
            this.orderList.totalSize = 0;
          } else {
            this.orderList.totalSize = result.total;
          }
          console.log(JSON.stringify(result.datalists));
          this.tableData = result.datalists;
        })
        .catch((error) => {
          this.orderLoading = false;
        });
    },
    gotoPay() {
      this.$router.push({ path: "/pay" });
      this.$store.commit("asideMenuId", "pay");
    },
    selectChange(value) {
      this.currentValue = value;
      this.options.forEach((item) => {
        if (item.value == this.currentValue) {
          this.currentPrice = item.price;
          this.currentTimes = item.times;
        }
      });
    },
    formatUseState(row) {
      return row.status == 0 ? "成功" : "异常"; //1可用，2 已用，3过期
    },
    formatDate(row) {
      //格式化时间
      var t = new Date(row.fspPaytime); //row 表示一行数据, updateTime 表示要格式化的字段名称
      var year = t.getFullYear(),
        month = t.getMonth() + 1,
        day = t.getDate(),
        hour = t.getHours(),
        min = t.getMinutes(),
        sec = t.getSeconds();
      var newTime =
        year +
        "-" +
        (month < 10 ? "0" + month : month) +
        "-" +
        (day < 10 ? "0" + day : day) +
        " " +
        (hour < 10 ? "0" + hour : hour) +
        ":" +
        (min < 10 ? "0" + min : min) +
        ":" +
        (sec < 10 ? "0" + sec : sec);
      return newTime;
    },
    formatDate1(row) {
      //格式化时间
      var t = new Date(row.createTime); //row 表示一行数据, updateTime 表示要格式化的字段名称
      var year = t.getFullYear(),
        month = t.getMonth() + 1,
        day = t.getDate(),
        hour = t.getHours(),
        min = t.getMinutes(),
        sec = t.getSeconds();
      var newTime =
        year +
        "-" +
        (month < 10 ? "0" + month : month) +
        "-" +
        (day < 10 ? "0" + day : day) +
        " " +
        (hour < 10 ? "0" + hour : hour) +
        ":" +
        (min < 10 ? "0" + min : min) +
        ":" +
        (sec < 10 ? "0" + sec : sec);
      return newTime;
    },
    noBanlances() {
      //余额不足
      this.tableDatas = [];
      this.isSureDownload = false;
    },
    sureBuyTimes() {
      //参数
      let msg =
        "是否确认花费" +
        this.currentPrice +
        "元，购买" +
        this.currentTimes +
        "次搜图次数？购买后不支持退费";
      MessageBox.confirm(msg, "温馨提示", {
        confirmButtonText: "确定购买",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let dataform = {
          price: this.currentPrice,
          searchTime: this.currentTimes,
        };
        findTimesPay(dataform)
          .then((result) => {
            message.success({
              message: "购买成功",
              duration: 4000,
              offset: 80,
            });
            this.getUserList();
            this.getOrderTableDatas();
          })
          .catch((error) => {
            message.error({
              message: error.message,
              duration: 4000,
              offset: 80,
            });
          });
      });
    },
  },
};
</script>

<style scoped lang="scss">
$green: rgb(24, 210, 107);
$grey: #8a98ac;
$primary: rgb(0, 128, 255);

.mb {
  margin-bottom: 1em;
}
h3 {
  font-size: 26px;
  font-weight: 600;
  line-height: 1.2;
  margin-bottom: 0.5em;
}

.dropdown {
  margin-bottom: 15px;
}

.font-14 {
  font-size: 14px;
}

.font-26 {
  font-size: 26px;
}
.green {
  color: $green;
}
.grey {
  color: $grey;
}
.primary {
  color: $primary;
}
.card {
  font-size: 15px;
  border-radius: 3px;
  background-color: white;
  margin-bottom: 20px;
  padding: 20px;
  .card-header {
    color: black;
    font-size: 16px;
    margin-bottom: 30px;
  }
  .card-body {
    padding-bottom: 0;
  }
}
::v-deep .el-collapse-item__header {
  font-size: 16px;
  font-weight: 600;
  color: rgb(0, 128, 255);
  background-color: rgba(129, 167, 205, 0.1);
  text-align: left;
  padding: 0 15px;
  border-top: 1px solid rgba(0, 0, 0, 0.03);
  border-left: 1px solid rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid transparent;
  border-right: 1px solid rgba(0, 0, 0, 0.03);
  border-radius: 0px;
}

.text-center {
  text-align: center;
}

.expire-tag {
  font-size: 10px;
  padding: 3px;
  border-radius: 2px;
  font-weight: 500;
  background-color: rgba(24, 210, 107, 0.1);
  color: rgb(24, 210, 107);
  margin: 0 8px;
}

::v-deep .el-collapse-item__wrap {
  border-bottom: none;
}

.buy-notice {
  font-size: 15px;
  padding: 1.25em 1.25em 1.25em 40px;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-top: none;

  li {
    list-style: disc;
    color: $grey;
    line-height: 2em;
  }
}

.select-container {
  margin-bottom: 15px;
  width: 100%;
}

.upload-demo {
  ::v-deep .el-upload {
    width: 100%;

    .el-upload-dragger {
      width: 100%;
      min-height: 250px;
      line-height: 250px;
    }
  }
  .el-upload__text {
    color: $grey;
    font-size: 30px;
  }
}

.copy-title {
  margin-top: 15px;
  margin-bottom: 15px;
  font-weight: 500;
  font-size: 15px;
}

.tips {
  padding: 15px 20px;
  border-radius: 3px;
  margin-bottom: 1em;

  &.greenBg {
    background-color: rgb(212, 237, 218);
  }

  &.greenFont {
    color: $green;
  }

  &.redBg {
    background-color: rgb(248, 215, 218);
  }

  &.redFont {
    color: rgb(255, 63, 63);
  }

  &.blueBg {
    background-color: rgb(204, 229, 255);
  }

  &.blueFont {
    color: blue;
  }
}

.input {
  margin-bottom: 1em;
}

.flex {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  .half {
    flex: 1;
  }
}

.recognize-row {
  margin-top: 20px;
  padding: 10px 0;
  .recognize-number {
    margin-left: 10px;
    font-size: 26px;
    font-weight: 600;
  }
}

.dot-wrapper {
  display: flex;
  align-items: center;
  padding: 1px 0;
  .dot {
    width: 12px;
    height: 12px;
    margin-right: 8px;
    display: inline-block;
    border-radius: 50%;

    &.green {
      background: $green;
    }

    &.primary {
      background: $primary;
    }

    &.grey {
      background: $grey;
    }
  }
}

.expire-time-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.pay-first {
  margin-bottom: 30px;
}

.bg {
  width: 67px;
  height: 67px;
}

.bg-row {
  height: 80px;
  padding: 3px 0;
  align-items: flex-end;
}

.search-success-title {
  font-size: 16px;
}
.search-number-input {
  width: 200px;
}

.flex-card {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;

  .left {
    flex: 1;
    min-width: 500px;
  }
  .right {
    flex: 1;
    min-width: 500px;
  }
}
</style>
